"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateMachine = void 0;
exports.createCommonStateManager = createCommonStateManager;
class StateMachine {
    constructor(config) {
        this.subscribers = [];
        this.currentState = config.inititialState ?? { state: 'IDLE' };
        this.stateList = config.stateList;
    }
    init(state) {
        this.setState(state);
    }
    getCurrentState() {
        return this.currentState;
    }
    isValidTransition({ state: nextStateInput }) {
        return !!this.stateList[this.currentState.state]?.transitions.some(transition => transition === nextStateInput);
    }
    onExit(callback) {
        callback();
    }
    onEnter() {
        // implement later
    }
    onUpdate() {
        this.subscribers.forEach(callback => callback(this.currentState));
    }
    setSubscribers(subscribers) {
        this.subscribers = subscribers;
    }
    setState(nextState) {
        this.currentState = {
            state: nextState.state,
            type: nextState.type,
            data: nextState.data,
        };
        this.onUpdate();
    }
    onTransition(nextState, callback) {
        if (nextState.state === this.currentState.state && nextState.type === this.currentState.type) {
            return;
        }
        const isValid = this.isValidTransition(nextState);
        if (isValid) {
            callback && this.onExit(callback);
            this.setState(nextState);
            this.onEnter();
        }
        else {
            throw new Error(`Invalid state transition for: ${this.currentState.state}`);
        }
    }
}
exports.StateMachine = StateMachine;
function createCommonStateManager(config) {
    return new StateMachine(config);
}
//# sourceMappingURL=StateMachine.js.map